export default (initialTarget = null, initialOffset = 0) => ({
    
    offset: initialOffset,
    target: initialTarget,

    handleScroll(){
        
        let offsetTop = this.offset;

        if(this.target)
        {           
            let target = document.getElementById(this.target);
            offsetTop = target.offsetTop;
        }

        offsetTop = offsetTop - 60;

        window.scrollTo({top: offsetTop, behavior: 'smooth'})
    }
});